/*
    Parent component of while application
 */
import React from 'react';
import '../App.css';
import LoginPage, { Operations } from './login_page';
import UnsubscribePage from './unsubscribe_page';
import PrintDataPage from './print-data-page';
import VerificationErrorPage from './verification_error';
import TabbedContent from '../containers/tabbed_content';
import PrinterConnectingTutorial from '../components/printer-connecting-tutorial';
import PlanSelectionPage from '../containers/plan-selection';
import TermsAndConditionsPage from '../components/TermsAndConditions';
import PrintRecordPage from '../components/print-record-page';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';

class App extends React.Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path='/' component={TabbedContent}/>
                    <Route path={`/:operation(${Operations.LOGIN}|${Operations.SIGNUP}|${Operations.RESET_PWD}|${Operations.PRINT_DATA_LOGIN}|${Operations.PRINT_RECORD_LOGIN})`} component={LoginPage}/>
                    <Route path='/verificationError' component={VerificationErrorPage}/>
                    <Route path='/printer-connecting-tutorial' component={PrinterConnectingTutorial}/>
                    <Route path='/select-plan' component={PlanSelectionPage}/>
                    <Route path='/terms-and-conditions' component={TermsAndConditionsPage}/>
                    <Route path='/unsubscribe' component={UnsubscribePage}/>
                    <Route path='/printData' component={PrintDataPage}/>
                    <Route path='/account' component={TabbedContent}/>
                    <Route path='/customerSupportAnaylitics' component={PrintRecordPage}/>
                </Switch>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js